import script from "./EditButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EditButton.vue?vue&type=script&setup=true&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=cf6e9f44&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf6e9f44"]])

export default __exports__